import { IconButton, LinkProps } from '@chakra-ui/react';
import React from 'react';
import Button from '~/components/Button';
import Link from '~/components/Link';
import { ShareIcon } from '~/components/icons';
import { useBreakpointValue } from '~/utils-ts';

interface Props extends LinkProps {
  buttonText?: string;
  shouldBeResponsive?: boolean;
}

export const ShareButton: React.FC<Props> = ({
  buttonText = 'Preview & Share',
  href,
  shouldBeResponsive = true,
  ...props
}) => {
  const isMobile = useBreakpointValue({ base: true, md: false });

  return (
    <Link
      href={href}
      isExternal
      _hover={{
        textDecoration: 'none',
      }}
      rel="noopener noreferrer"
      {...props}
    >
      {isMobile && shouldBeResponsive ? (
        <IconButton
          colorScheme="primary"
          size="sm"
          isRound
          aria-label="Share media pack"
          variant="solid"
          icon={<ShareIcon color="white" boxSize={4} />}
        />
      ) : (
        <Button
          colorScheme="primary"
          fontWeight="medium"
          rounded="full"
          size="sm"
          leftIcon={<ShareIcon color="white" boxSize={4} />}
        >
          {buttonText}
        </Button>
      )}
    </Link>
  );
};
